const animations = () => {
    gsapAnimations();

    $(window).on('scroll', function() {
        animateSection();
    });
    $(window).trigger('scroll');

    // Change background colour on scroll
    var backgroundContainerTop = $(window).scrollTop() + $(window).height() + 100;
    var backgroundContainerHeight = $(document).height() - (backgroundContainerTop + $('footer').outerHeight());

    $(window).on('scroll', function() {
        if ( $(window).scrollTop() > backgroundContainerTop ) {
            var percentage = (($(window).scrollTop() - backgroundContainerTop) / backgroundContainerHeight) * 100;

            $('.background__image').css('background-color', '#091a30');

            if ( percentage > 33.3333 && percentage <= 66.6666 ) {
                $('.background__image').css('background-color', '#06111f');
            }

            if ( percentage > 66.6666 ) {
                $('.background__image').css('background-color', '#10111C');
            }
        } else {
            $('.background__image').removeAttr('style');
        }
    });  
    
	// Homepage Scroll Section
	$('.js__scroll-section').on('click', function(e) {
		e.preventDefault();

		var currentSection = $(this).closest('.module');
		var nextSection = currentSection.next();
		var headerHeight = $('header').outerHeight();

		$('html, body').animate({
        	scrollTop: nextSection.offset().top - headerHeight
      	}, 800);		
	});
    
	// Inquire Link
	$('.js__inquire-link, .inquire-link').on('click', function(e) {
		e.preventDefault();

		if ( $('.form__module').length ) {
			var headerHeight = $('header').outerHeight() + 30;
			
			$('html, body').animate({
	        	scrollTop: $('.form__module').offset().top - headerHeight
	      	}, 800);				
		}
	});    
};

const gsapAnimations = () => {
    let tl;

    // Homepage Hero Section
    if ( $('body').hasClass('home') || $('body').hasClass('page-template-peakaboo') && $('.hero__section').length ) {
        tl = gsap.timeline({onComplete: animateScrollDown});
        tl.to('.hero__section-scroll-text', {duration: 0.8, opacity: 1, y: 0});
        tl.to('.hero__section-subheading, .hero__section-heading', {duration: 0.8, opacity: 1, y: 0}, "-=0.6");
        tl.to('.hero__section-logo', {duration: 0.8, opacity: 1,}, "-=0.4");
    }

    if ( !$('body').hasClass('home') || !$('body').hasClass('page-template-peakaboo') && $('.hero__section').length ) {
        tl = gsap.timeline();
        tl.to('.hero__section-heading', {duration: 0.8, opacity: 1, y: 0});
        tl.to('.hero__section-subheading', {duration: 0.8, opacity: 1, y: 0}, "-=0.6");
        tl.to('.hero__section-link', {duration: 0.8, opacity: 1, y: 0}, "-=0.6");
    }
};

const animateScrollDown = () => {
    $('.hero__section-scroll-line').addClass('animate');
};

const animateSection = () => {
    var windowTop = $(window).scrollTop();
    var windowBottom = windowTop + $(window).height();

    $('.anim__elem').each(function() {
        var offset = 40;
        var elementTop = $(this).offset().top + offset;
        var fadeType = $(this).data('fade-type');

        if ( windowBottom > elementTop ) { // Section is in view
            $(this).addClass('in-view');
        }
    });
};

// Popup animations
const closePopupAnimation = (callback) => {
    let tl;
    if ( callback ) {
        tl = gsap.timeline({onComplete: openNewPopup});
        tl.to('.popup', {duration: 0.4, opacity: 0, onComplete: closePopup});			
    } else {
        tl = gsap.timeline();
        tl.to('.popup', {duration: 0.4, opacity: 0, onComplete: closePopup});			
    }
};

const openNewPopup = () => {
    openPopup('booking');
    let tl;
    tl = gsap.timeline();
    tl.to('.popup', {duration: 0.4, opacity: 1});
    tl.from('.popup__header .js__popup-close, .popup__header-image', {duration: 0.4, opacity: 0});
    tl.from('.popup__booking-header', {duration: 0.4, y: 20, opacity: 0});
    tl.from('.popup__booking-content p', {duration: 0.6, y: 30, opacity: 0, stagger: 0.1}, '-=0.2');
    tl.from('.popup__item-signup-form', {duration: 0.4, y: 20, opacity: 0}, '-=0.2');			
};

const openNavPopupAnimation = () => {
    let tl;
    tl = gsap.timeline();
    tl.to('.popup', {duration: 0.4, opacity: 1});
    tl.from('.popup__header .js__popup-close', {duration: 0.4, opacity: 0});
    tl.addLabel('navItems');
    tl.from('.popup__item.open .popup__item-nav .menu-item', {
        duration: 0.8, 
        y: 30, 
        opacity: 0, 
        stagger: -0.1, 
        onStart: animatePopupLine}, 'navItems');
    tl.from('.popup__item.open .popup__item-booking-btn, .popup__header-image', {opacity: 0, duration: 0.8}, '-=0.7');
    tl.from('.popup__item.open .popup__item-opening-hours-group', {duration: 0.8, y: 30, opacity: 0, stagger: -0.1}, 'navItems');
    tl.from('.popup__item.open .popup__item-heading', {duration: 0.8, y: 30, opacity: 0}, 'navItems');
};

const animatePopupLine = () => {
    $('.popup__item.open .popup__item-nav-line').addClass('animate');
};

const openVacanciesPopupAnimation = () => {
    let tl;
    tl = gsap.timeline();
    tl.to('.popup', {duration: 0.4, opacity: 1});
    tl.from('.popup__header .js__popup-close, .popup__header-image', {duration: 0.4, opacity: 0});
    tl.from('.popup__vacancies-header', {duration: 0.4, y: 20, opacity: 0});
    tl.from('.popup__vacancies-iframe', {duration: 0.6, y: 30, opacity: 0}, '-=0.2');	
};